module.exports = __webpack_public_path__ + "static/media/itakeoff.8188d4fe.png";